/**
 * 系统版本常量定义
 */
export const VERSION_TYPES = {
  C9BS: 'C9BS',
  C9BS_CALL_CAR: 'C9BS调车版',
  CCBS: 'CCBS'
}
